<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="30"
    viewBox="0 0 38 30"
  >
    <path
      fill="none"
      fill-rule="evenodd"
      stroke="#5CD18A"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="4"
      d="M2 16.612L12.356 28 36 2"
    />
  </svg>
</template>